export default function ArrowLeftCarousel({ color = "white", width = "12", height = "20" }) {
    return (
        <svg width={width} height={height} viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2.12L4.19802 10L12 17.88L9.90099 20L0 10L9.90099 0L12 2.12Z" fill={color}/>
</svg>

    )
}